/** "Data as of Oct 25 · GBL season: Forever Forward" under the landing hero (BUG-22).
 *  Renders nothing until /freshness answers, and nothing if it fails. */
import { useEffect, useState } from "react";
import { freshnessText, getFreshness } from "../lib/freshness";

export default function FreshnessLine() {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    void getFreshness().then((f) => {
      if (alive) setText(freshnessText(f));
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!text) return null;
  return <p className="text-xs text-white/30 pt-1">{text}</p>;
}
